<app-titulo texto="Situação Atendimento "></app-titulo>
<p class="text-md font-opensans text-700">
  Essa página dedica-se exclusivamente para verificar a situação das demandas já abertas através de nossos Canais de
  Atendimento.
</p>
<p class="text-md font-opensans text-700">
  Existem dois tipos distintos de protocolos, cada um vinculado a um canal de atendimento diferente. Atente-se ao
  número de dígitos para utilizar o campo correto de consulta
</p>

<ng-container *ngIf="!dadosAtendimento && !dadosProtocolo">
  <p class="text-md font-opensans text-800">
    <span class="text-md font-opensans text-800 font-bold">1. Protocolo de Serviço Geral (18 dígitos) - (Exemplo:
      16012077 1035
      009999)</span><br />
    Utilizado para solicitações registradas por meio dos seguintes canais de atendimento:
  </p>
  <ul>
    <li class="text-sm font-opensans text-800 font-bold">Central de Atendimento Telefônico</li>
    <li class="text-sm font-opensans text-800 font-bold">Chat</li>
    <li class="text-sm font-opensans text-800 font-bold">Aplicativo CASAN</li>
    <li class="text-sm font-opensans text-800 font-bold">Portal e-CASAN</li>
    <li class="text-sm font-opensans text-800 font-bold">WhatsApp</li>
    <li class="text-sm font-opensans text-800 font-bold">Atendimento Presencial</li>
  </ul>
  <p>Para consultar esse tipo de solicitação, você deve:</p>
  <ul>
    <li class="text-sm font-opensans text-800">Informar o <span class="font-bold">número do protocolo</span>, composto
      por <span class="font-bold">18
        números</span>;
    </li>
    <li class="text-sm font-opensans text-800">Clicar em <span class="font-bold">“Pesquisar”</span>.</li>
  </ul>

  <div class="w-full flex flex-column align-items-center justify-content-center gap-2 mt-4 md:flex-row">
    <label class="font-bold">Número do Protocolo: </label>
    <p-inputMask placeholder="Digite aqui seu protocolo" mask="99/99/9999 99:99 9?9999999" styleClass="w-14rem"
      [(ngModel)]="protocolo" />
  </div>

  <p-button type="submit" label="Pesquisar" styleClass="w-full mt-4" [loading]="loading" [disabled]="!protocolo"
    (onClick)="pesquisarProtocolo()"></p-button>

  <p class="text-md font-opensans text-800">
    <span class="text-md font-opensans text-800 font-bold">2. Solicitação de Serviços Online (11 dígitos) - (Exemplo:
      0368750 2019);</span><br />
    Utilizado exclusivamente para solicitações abertas por meio do canal:
  </p>
  <ul>
    <li class="text-sm font-opensans text-800 font-bold">Atendimento Online (via Site da CASAN)</li>
  </ul>
  <p>Para consultar esse tipo de solicitação, você deve:</p>
  <ul>
    <li class="text-sm font-opensans text-800">Informar o <span class="font-bold">número do
        protocolo</span>, composto por <span class="font-bold">11
        números</span>;
    </li>
    <li class="text-sm font-opensans text-800">Clicar em <span class="font-bold">“Pesquisar”</span>.</li>
  </ul>
  <p class="text-md font-opensans text-800"><span class="font-bold">Observação:</span> Quando o
    Atendimento Online for finalizado pelo
    atendente, será
    gerado um protocolo de 18 dígitos que poderá ser consultado na opção número 1.</p>

  <div class="w-full flex flex-column align-items-center justify-content-center gap-2 mt-4 md:flex-row">
    <label class="font-bold">Número do Atendimento: </label>
    <div class="p-inputgroup md:w-20rem">
      <span class="p-inputgroup-addon"> AD </span>
      <input pInputText type="number" placeholder="Número" [(ngModel)]="id" />
      <span class="p-inputgroup-addon"> / </span>
      <input pInputText type="number" placeholder="ano" [(ngModel)]="ano" />
    </div>
  </div>
  <p-button type="submit" label="Pesquisar" styleClass="w-full mt-4" [loading]="loading" [disabled]="!id || !ano"
    (onClick)="pesquisar()"></p-button>
</ng-container>

<ng-container *ngIf="dadosProtocolo">
  <p-panel header="Detalhes do Protocolo">
    <div>
      <label style="font-weight: bold">Protocolo:</label>
      {{ dadosProtocolo.protocoloFormatado }}
    </div>
    <hr />
    <div [innerHTML]="dadosProtocolo.texto"></div>
    <p-button styleClass="w-full mt-4" type="button" label="Confirmar conclusão de abrigo padrão"
      *ngIf="dadosProtocolo.situacao == 7" (click)="confirmarAbrigoPadrao($event)"></p-button>
  </p-panel>
</ng-container>

<ng-container *ngIf="dadosAtendimento">
  <p-panel header="Detalhes do atendimento">
    <div class="flex flex-column gap-2">
      <div class="flex gap-2">
        <span class="font-bold">Atendimento Nº:</span>
        <span>{{ dadosAtendimento.codigoFormatado }}</span>
      </div>
      <div class="flex gap-2 pt-2 border-top-1 surface-border">
        <label class="font-bold">Serviço Solicitado:</label>
        <span> {{ dadosAtendimento.servico }}</span>
      </div>
      <div class="flex gap-2 pt-2 border-top-1 surface-border">
        <label class="font-bold">Localidade:</label>
        <span> {{ dadosAtendimento.localidade }}</span>
      </div>
      <div class="flex gap-2 pt-2 border-top-1 surface-border">
        <label class="font-bold">Data de abertura:</label>
        <span>
          {{ dadosAtendimento.dataCadastro | date : "dd/MM/yyyy HH:mm" }}</span>
      </div>

      <div class="flex gap-2 pt-2 border-top-1 surface-border">
        <label class="font-bold">Situação do atendimento:</label>
        <span *ngIf="!dadosAtendimento.situacaoServico" [innerHTML]="dadosAtendimento.situacao.description"></span>

        <span *ngIf="!dadosAtendimento.situacaoServico">
          - {{ dadosAtendimento.dataSituacao | date : "dd/MM/yyyy HH:mm" }}
        </span>

        <span *ngIf="dadosAtendimento.situacaoServico"
          [innerHTML]="dadosAtendimento.situacaoServico.description"></span>
      </div>

      <div class="flex gap-2 pt-2 border-top-1 surface-border" *ngIf="dadosAtendimento.protocolo">
        <label class="font-bold">Protocolo do serviço:</label>
        <span [innerHTML]="dadosAtendimento.protocolo"></span>
      </div>

      <div class="flex gap-2 py-2 border-top-1 surface-border" *ngIf="
          dadosAtendimento.justificativa &&
          dadosAtendimento.situacao.code != SITUACAO_PENDENTE
        ">
        <label class="font-bold">Justificativa:</label>
        <pre [innerHTML]="dadosAtendimento.justificativa" style="
            font-family: 'Open Sans', sans-serif;
            white-space: pre-wrap;
            margin: 0px;
          "></pre>
      </div>
      <div class="flexgap-2 pt-2 border-top-1 surface-border" *ngIf="dadosAtendimento.podeEnviarArquivoComplementar">
        <h4 class="my-2">DOCUMENTOS COMPLEMENTARES DIGITALIZADOS</h4>
        <h5 class="my-2 font-normal">
          Favor inserir a documentação faltante, conforme detalhado no campo
          'Justificativa':
        </h5>

        <p-fileUpload [disabled]="loading" [showUploadButton]="false" [fileLimit]="6" [multiple]="true"
          [customUpload]="true" [maxFileSize]="TAMANHO_MAXIMO_ARQUIVOS" chooseLabel="Selecionar arquivos"
          cancelLabel="Limpar arquivos" class="file" accept="image/*,application/pdf"
          invalidFileSizeMessageSummary="Tamanho máximo de arquivo excedido"
          invalidFileSizeMessageDetail="Tamanho máximo do arquivo é de {0}"
          invalidFileTypeMessageSummary="Tipo de arquivo inválido"
          invalidFileTypeMessageDetail="Os arquivos permitidos são: {0}"
          invalidFileLimitMessageSummary="Número de arquivos máximo excedido"
          invalidFileLimitMessageDetail="Número máximo de arquivos é de {0}" (onSelect)="onFileSelect($event)"
          (onRemove)="onFileRemove($event)" (onClear)="onClearFiles($event)">
          <ng-template pTemplate="toolbar">
            <div>
              <sub>É PERMITIDO SELECIONAR ATÉ 6 ARQUIVOS</sub>
            </div>
          </ng-template>
        </p-fileUpload>
        <p-button type="submit" [disabled]="anexos.length == 0" label="Enviar Documentos" styleClass="w-full mt-4"
          [loading]="loading" (onClick)="enviarArquivos()"></p-button>
      </div>
    </div>
  </p-panel>
  <div class="text-700 mb-4 text-sm">
    <p class="font-bold">
      <span class="text-red-500">Importante!</span> Caso o campo ‘Situação’ do
      seu atendimento seja:
    </p>
    <ul class="list-none flex flex-column gap-2 m-0 p-0">
      <li *ngFor="let d of decricaoSituacao">
        <label class="font-bold">{{ d.label }}:</label> {{ d.descricao }}
      </li>
      <li></li>
    </ul>
  </div>
</ng-container>